const DEFAULT_STORE_NAMES = new Set(['mi tienda de ropa', 'mi tienda', '']);

/** Nombre visible: evita defaults del POS si la tienda ya tiene nombre real. */
export function resolveRetailStoreName(storeConfig, activeStore) {
  const cfg = String(storeConfig?.nombreNegocio || '').trim();
  const fromStore = String(activeStore?.store_name || '').trim();

  if (cfg && !DEFAULT_STORE_NAMES.has(cfg.toLowerCase())) return cfg;
  if (fromStore && !DEFAULT_STORE_NAMES.has(fromStore.toLowerCase())) return fromStore;
  return cfg || fromStore || 'Tienda';
}

export function slugifyForInput(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 50);
}

export const SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{1,48}[a-z0-9]$/;
